import { default as useBadge } from "./create-badge"

export default useBadge
